<template>
    <b-modal
        id="checkoutModal"
        v-model="offerModal"
        size="xl"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="dark"
        body-bg-variant="dark"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideTempModal');onHide($event)"
    >

        <div class="modal-body">
            <div class="close-button" @click="$emit('hideTempModal')">X</div>
            <div class="modal-header">
                <span>Solicitare ofertă personalizată</span>
            </div>
            <div class="videoWrapper">
                <validation-observer #default="{ invalid2 }" ref="offerForm">
                    <span class="display-none">{{ invalid2 }}</span>
                    <b-form class="pt-2">
                        <div>
                            <div>
                                <b-form-group
                                    id="email-group"
                                    label="CE VREI SĂ CUMPERI?* (Cât mai multe detalii)"
                                    label-for="product"
                                    class="w-100 position-relative"
                                >
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        name="produs"
                                    >
                                        <b-form-textarea
                                            id="product"
                                            v-model="form.product"
                                            rows="5"
                                            :style="form.product ? {color: '#000000'} : ''"
                                            :state="errors.length > 0 ? false : null"
                                            placeholder="Te rugăm să ne oferi cât mai multe detalii, marcă, model, brand etc."
                                            class="w-100"
                                        >
                                        </b-form-textarea>
                                        <small class="text-danger" style="display: block; bottom: 3px; height: inherit; right: 3px;">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group
                                    id="price-group"
                                    label="LINKURI PRODUS (Ne ajută un link, ne dăm seama mai ușor ce îți dorești)"
                                    label-for="link"
                                    class="w-100 position-relative"
                                >
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="url"
                                        name="link"
                                    >
                                        <b-form-input
                                            id="link"
                                            v-model="form.link_one"
                                            :style="form.link_one ? {color: '#000000'} : ''"
                                            :state="errors.length > 0 ? false : null"
                                            placeholder="www.furnizor.ro/produs/test"
                                            class="w-100 mb-2"
                                        >
                                        </b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group
                                    id="price-group"
                                    label-for="link"
                                    class="w-100 position-relative"
                                >
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="url"
                                        name="link"
                                    >
                                        <b-form-input
                                            id="price"
                                            v-model="form.link_two"
                                            :style="form.link_two ? {color: '#000000'} : ''"
                                            :state="errors.length > 0 ? false : null"
                                            placeholder="www.furnizor.ro/produs/test"
                                            class="w-100"
                                        >
                                        </b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </div>
                            <div>
                                <div class="info-solicitare">
                                    <p class="mb-3"><strong>SOLICITARE TRANSMISĂ DE:</strong></p>
                                    <p class="mb-0">{{ form.name }}</p>
                                    <p class="mb-0">Pentru {{ form.business_name.substring(0, 20) }}<span
                                        v-if="form.business_name.length > 25"
                                    >...</span></p>
                                    <p class="mb-0">{{ form.email }}</p>
                                    <p class="mb-3">{{ form.phone }}</p>
                                    <p class="mt-4 mb-2"><strong>SOLICITARE TRANSMISĂ CĂTRE:</strong></p>
                                    <p class="mb-3">{{ getCompanyName().toUpperCase() }}</p>
                                </div>
                                <div class="send-button-hub" @click="sendOffer()">
                                    <p>Trimite solicitarea ta</p>
                                </div>
                            </div>
                        </div>
                    </b-form>
                </validation-observer>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {BModal, BForm, BFormGroup, BFormInput, BButton, BIconTrash, BFormTextarea, BFormFile, BIconUpload} from 'bootstrap-vue';
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import axios from '@/helpers/axios'
    import api from '@/helpers/api'
    require('@/helpers/validations/validations')
    export default {
        components: {
            BModal,
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            BIconTrash,
            BFormTextarea,
            BFormFile,
            BIconUpload,
            ValidationProvider, ValidationObserver
        },
        props: {
            offerModal: {
                type: Boolean,
                default: false
            },
            currentOffer: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                form: {
                    product: '',
                    link_one: '',
                    link_two: '',
                    name: '',
                    email: '',
                    phone: '',
                    business_name: '',
                },
                offerSending: false,
                isPaid: false
            };
        },
        mounted() {
            this.isPaid = JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).paid : null
            this.form.name = this.$store.getters['auth/user'].name
            this.form.email = this.$store.getters['auth/user'].email
            this.form.phone = this.$store.getters['auth/user'].phone
            this.form.business_name =  JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).name : ''
        },
        methods: {
            getCompanyName() {
                if(this.currentOffer === 'ircat'){
                    return 'IRCAT-CO SRL'
                } else if(this.currentOffer === 'nod'){
                    return 'Network One Distribution'
                } else if(this.currentOffer === 'kinnarps'){
                    return 'Kinnarps'
                } else if(this.currentOffer === 'cat'){
                    return 'Bergerat Monnoyeur CAT'
                } else if(this.currentOffer === 'eurogastro'){
                    return 'Eurogastro'
                } else if(this.currentOffer === 'trust'){
                    return 'Trust Expert'
                } else if(this.currentOffer === 'goodwill'){
                    return 'Goodwill Energy'
                }else if(this.currentOffer === 'brorom'){
                    return 'Bro Rom Industrial Machines SRL'
                } else {
                    return 'Nedavi Solar'
                }
            },
            onHide(evt) {
                if(evt.trigger === "backdrop"){
                    evt.preventDefault();
                    this.$emit('hideTempModal')
                }
            },
            sendOffer() {
                if(!this.offerSending) {
                    this. offerSending = true
                    this.$refs.offerForm.validate().then((e) => {
                        if (!e) {
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                            this.offerSending = false
                        } else {
                            if(this.isPaid) {
                                axios.post(api.API_ENDPOINTS.offerForm + this.currentOffer, this.form)
                                    .then((response) => {
                                        this. offerSending = false
                                        this.form.product = ''
                                        this.form.link_one = ''
                                        this.form.link_two = ''
                                        this.$emit('hideTempModal');
                                        this.$emit('offerSent', response.data.message)
                                    }).catch((xhr) => {
                                        this. offerSending = false
                                        this.$toast.error(xhr.response.data.message);
                                    });
                            } else {
                                this.$swal({
                                    title: 'Funcție disponibilă companiilor cu licență activă.<br>Poți cumpăra o licență din pagina de mai jos.',
                                    icon: 'info',
                                    confirmButtonText: 'Cumpără licență',
                                    showDenyButton: true,
                                    denyButtonText: 'Anulează'
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.$router.push({name: 'M3SketchCumparaLicenta'});
                                    }
                                })
                            }

                        }
                    })
                }
            }
        },
    };
</script>

<style scoped>
.modal-body{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.modal-body >>> .modal-header span {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 30px;
}
.modal-body >>> .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    position: relative;
}
.close-button{
    position: absolute;
    right: 0;
    top: 0;
    font-size: 11px;
    line-height: 1;
    font-weight: 600;
    color: #000;
    background: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
form >>> label {
    color: #f0f0f0;
    font-size: 14px;
    font-weight: 300;
}
form >>> textarea {
    border-radius: 4px;
    border: none;
    color: #aebdcd;
    background: #f0f0f0;
    font-size: 14px;
}
form >>> input {
    border-radius: 4px;
    border: none;
    color: #aebdcd;
    background: #f0f0f0;
    font-size: 14px;
}
form >>> textarea::placeholder, form >>> input::placeholder {
    opacity: 0.8;
    color: #aebdcd;
}
.send-button-hub {
    background: #f0f0f0;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 7px;
    margin-bottom: 1rem;
    cursor: pointer;
    transition: 0.4s;
}
.send-button-hub:hover {
    background: #d0cccc;
}
.send-button-hub p {
    font-weight: 700;
    font-size: 14px !important;
}
.info-solicitare{
    margin: 35px 0;
}
.info-solicitare p{
    font-size: 14px;
    color: #fff;
    text-align: center;
}
</style>
